import React, { useMemo, useState } from 'react'
import {
  FullTitle,
  PropertyCount,
  PropertyCounts,
  SectionalTitle,
  SpiderSearchResponse,
} from '../../api/Spider'
import '../kyc/SearchResultsTable.css'
import { EmptyMessage } from '../kyc/EmptyMessage'
import { RxCross1 } from 'react-icons/rx'
// import { EmptyMessage } from '../EmptyMessage'

export interface TableDataPropertyCountsProps {
  results?: PropertyCounts | null
  title: string
  onFullTitleRowClick?: (row: PropertyCount) => void
  onSectionalTitleRowClick?: (row: PropertyCount) => void
  onClose?: () => void
}

export const TableDataPropertyCounts: React.FC<
  TableDataPropertyCountsProps
> = ({
  results,
  title,
  onFullTitleRowClick,
  onSectionalTitleRowClick,
  onClose,
}) => {
  const handleFullTitleClick = (erf: FullTitle) => () => {
    if (onFullTitleRowClick) onFullTitleRowClick(erf)
  }
  const handleSectionalTitleClick = (erf: SectionalTitle) => () => {
    if (onSectionalTitleRowClick) onSectionalTitleRowClick(erf)
  }

  const [titleType, setTitleType] = useState<'FULL' | 'SECTIONAL'>('FULL')

  const showEmpty = useMemo(
    () =>
      !results ||
      (titleType === 'FULL' && results?.fullTitlePropertyCount?.length === 0) ||
      (titleType === 'SECTIONAL' &&
        results?.sectionalTitlePropertyCount?.length === 0),
    [results],
  )

  if (results === undefined) return null

  return (
    <div className="kyc-results-table-container">
      <h1>{title}</h1>
      <div className="toggles">
        <div className="buttons">
          <div
            className={`tab-button ${titleType === 'FULL' ? 'active' : ''}`}
            onClick={() => setTitleType('FULL')}
          >
            Full Title {`(${results?.fullTitlePropertyCount?.length ?? 0})`}
          </div>
          <div
            className={`tab-button ${
              titleType === 'SECTIONAL' ? 'active' : ''
            }`}
            onClick={() => setTitleType('SECTIONAL')}
          >
            Sectional Title{' '}
            {`(${results?.sectionalTitlePropertyCount.length ?? 0})`}
          </div>
        </div>
        <RxCross1
          color="black"
          onClick={onClose}
          style={{ marginRight: '5px', cursor: 'pointer' }}
        />
      </div>
      <table>
        {titleType === 'FULL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th>Owner ID #</th>
              <th>Count</th>
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        {titleType === 'SECTIONAL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th>Owner ID #</th>
              <th>Count</th>
              {/* <th>Municipality Name</th> */}
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        <tbody style={{ height: '300px' }}>
          {showEmpty && <EmptyMessage />}
          {titleType === 'FULL' &&
            results?.fullTitlePropertyCount?.map((entry, index) => (
              <tr
                key={index}
                onClick={handleFullTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td>{entry.ownerIDNo}</td>
                <td>{entry.count}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
          {titleType === 'SECTIONAL' &&
            results?.sectionalTitlePropertyCount?.map((entry, index) => (
              <tr
                key={index}
                onClick={handleSectionalTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td>{entry.ownerIDNo}</td>
                <td>{entry.count}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default TableDataPropertyCounts
